import request from '@/utils/request'

// 获取课程学情分析
export function getCourseAnalysis(courseId) {
  return request({
    url: `/course-analysis/${courseId}`,
    method: 'get'
  })
}

// 生成课程学情分析
export function generateCourseAnalysis(courseId) {
  return request({
    url: `/course-analysis/generate/${courseId}`,
    method: 'post'
  })
}

// 获取课程学生列表
export function getCourseStudents(courseId) {
  return request({
    url: `/course-analysis/${courseId}/students`,
    method: 'get'
  })
}

// 获取学生在该课程的学习情况
export function getStudentCourseProgress(courseId, studentId) {
  return request({
    url: `/course-analysis/${courseId}/student/${studentId}`,
    method: 'get'
  })
}
